<script setup lang="ts">
import DRResponsiveBtn from "./DRResponsiveBtn.vue";

export interface DropdownOption {
  command: string;
  icon: string;
  title: string;
  description?: string;
}

withDefaults(
  defineProps<{
    icon?: string;
    label?: string;
    variant?:
      | "primary"
      | "secondary"
      | "outline"
      | "outline-danger"
      | "flat"
      | "flat-danger";
    size?: number;
    options: DropdownOption[];
  }>(),
  {
    icon: "bi-plus-lg",
    variant: "primary",
    size: 35,
  }
);

const emit = defineEmits<{
  (e: "command", command: string): void;
}>();
</script>

<template>
  <el-dropdown
    trigger="click"
    popper-class="dr-button-dropdown__popper"
    @command="(cmd: string) => emit('command', cmd)"
  >
    <DRResponsiveBtn
      :icon="icon"
      :variant="variant"
      :label="label"
      :size="size"
    />
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="option in options"
          :key="option.command"
          :command="option.command"
          class="dr-button-dropdown__item"
        >
          <div class="d-flex flex-column py-1">
            <div class="d-flex align-items-center gap-2">
              <el-icon size="1.5rem"><i :class="option.icon"></i></el-icon>
              <span class="fw-semibold text-h6">{{ option.title }}</span>
            </div>
            <span
              v-if="option.description"
              class="text-muted small ms-4 ps-2 pt-1"
            >
              {{ option.description }}
            </span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<style lang="scss">
.dr-button-dropdown__popper {
  min-width: 280px;
}

.dr-button-dropdown__item {
  height: auto !important;
  padding: 0.5rem 1rem !important;
  max-width: 320px;
  white-space: normal !important;
  line-height: 1.4;
}
</style>
